import type { WebPageSection } from "@/lib/api/types"
import { parseHtmlString } from '@/utils/helpers/html'

const AUAssemblySection = ({data}:{data: {
  [key: string]: WebPageSection
}}) => {
  return (
    <div className="bg-white">
      {/* First AU Assembly Section */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-6 items-center">
          <div className="flex flex-col justify-center items-start gap-6">
            <div className="min-h-[300px] md:min-h-96 px-6 md:px-8 py-6 bg-duskySky-100 flex justify-start items-start gap-2 overflow-hidden w-full">
              <div className="w-full flex flex-col justify-start items-start gap-8">
                <div className="flex flex-col justify-start items-start gap-4">
                  <h3 className="text-gray-100 text-xl md:text-2xl font-normal font-pt-serif leading-7">
                    AU Assembly's Strategic Leadership and Space Policy Adoption
                    {data?.LEADERSHIP_AU_ASSEMBLY_STRATEGIC_LEADERSHIP_AND_SPACE_POLICY?.title ?? ""}
                  </h3>
                  <div className="flex flex-col justify-start items-start gap-4">
                    <p className="text-gray-100 text-base md:text-lg font-normal font-satoshi leading-relaxed">
                      <span dangerouslySetInnerHTML={parseHtmlString(data?.LEADERSHIP_AU_ASSEMBLY_STRATEGIC_LEADERSHIP_AND_SPACE_POLICY?.description ?? "")} />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="min-h-[300px] md:min-h-96 px-6 md:px-8 py-6 bg-wine-100 flex justify-start items-start gap-2 overflow-hidden w-full">
              <div className="w-full flex flex-col justify-start items-start gap-8">
                <div className="flex flex-col justify-start items-start gap-4">
                  <h3 className="text-white text-xl md:text-2xl font-normal font-pt-serif leading-7">
                
                    {data?.LEADERSHIP_SPACE_AS_A_CATALYST_FOR_AFRICA_DEVELOPMENT?.title ?? ""}
                  </h3>
                  <div className="flex flex-col justify-start items-start gap-4">
                    <p className="text-white text-base md:text-lg font-normal font-satoshi leading-relaxed">
                      <span dangerouslySetInnerHTML={parseHtmlString(data?.LEADERSHIP_SPACE_AS_A_CATALYST_FOR_AFRICA_DEVELOPMENT?.description ?? "")} />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <img 
            src={data?.LEADERSHIP_BANNER_2?.fileUrl ?? "https://res.cloudinary.com/dlwegkhme/image/upload/v1757009431/0040be11ae89be9a11d108769c0d37bb175ca848_bkefxu.png"} 
            alt="AU Assembly Meeting - Large Group Photo"
            className="w-full h-[400px] md:h-[600px] lg:h-[759px] object-cover col-span-2"
          />
        </div>
      </div>

      {/* Second AU Assembly Section */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-6 items-center">
          <img 
            src={data?.LEADERSHIP_BANNER_3?.fileUrl ?? "https://res.cloudinary.com/dlwegkhme/image/upload/v1757009433/914f1274800ffe5ace0736277fc0dca024eea5f6_mzkwyr.png"} 
            alt="AU Assembly Meeting - Conference Room"
            className="w-full h-[400px] md:h-[600px] lg:h-[837px] object-cover lg:order-1 order-2 col-span-2"
          />
          
          <div className="flex flex-col justify-center items-start gap-6 lg:order-2 order-1">
            <div className="min-h-[300px] px-6 md:px-8 py-6 bg-wine-100 flex justify-start items-start gap-2 overflow-hidden w-full">
              <div className="w-full flex flex-col justify-start items-start gap-8">
                <div className="flex flex-col justify-start items-start gap-4">
                  <h3 className="text-white text-xl md:text-2xl font-normal font-pt-serif leading-7">
                   
                    {
                      data?.LEADERSHIP_AU_ASSEMBLY_ROLE_AND_THE_INAUGURATION_OF_THE_AFRICA_SPACE_COUNCIL?.title ?? ""
                    }
                  </h3>
                  <div className="flex flex-col justify-start items-start gap-4">
                    <p className="text-white text-base md:text-lg font-normal font-satoshi leading-relaxed">
                      {
                        data?.LEADERSHIP_AU_ASSEMBLY_ROLE_AND_THE_INAUGURATION_OF_THE_AFRICA_SPACE_COUNCIL?.description ?? ""
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="min-h-[300px] px-6 md:px-8 py-6 bg-duskySky-100 flex justify-start items-start gap-2 overflow-hidden w-full">
              <div className="w-full flex flex-col justify-start items-start gap-8">
                <div className="flex flex-col justify-start items-start gap-4">
                  <h3 className="text-gray-100 text-xl md:text-2xl font-normal font-pt-serif leading-7">
                    {data?.LEADERSHIP_SPACE_AS_A_DRIVER_OF_AFRICA_DEVELOPMENT_AND_UNITY?.title ?? ""}
                  </h3>
                  <div className="flex flex-col justify-start items-start gap-4">
                    <p className="text-gray-100 text-base md:text-lg font-normal font-satoshi leading-relaxed">
                      {
                        data?.LEADERSHIP_SPACE_AS_A_DRIVER_OF_AFRICA_DEVELOPMENT_AND_UNITY?.description ?? ""
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AUAssemblySection